var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"table"},[_c('Table',{attrs:{"border":"","columns":_vm.columns,"loading":_vm.loading,"data":_vm.dataList}})],1),_c('div',{staticClass:"page"},[_c('MyPage',{attrs:{"total":_vm.total,"current":_vm.page},on:{"changePage":_vm.changePage,"changePageSize":_vm.changePageSize}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }